import { render, staticRenderFns } from "./StratWaterfall.vue?vue&type=template&id=12681442&"
import script from "./StratWaterfall.vue?vue&type=script&lang=js&"
export * from "./StratWaterfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports